import { useState } from 'react';

export default function Header({ scrolled }: { scrolled: boolean }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled ? 'bg-white shadow-md' : 'bg-transparent'
    }`}>
      <nav className="max-w-7xl mx-auto px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/0fc33fa68f46f743570ad8ba1c3172ea/14439231e0fe547618927d677bb27025.png" 
              alt="Annalogix" 
              className="h-12 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <a href="#solutions" className={`text-sm font-medium transition-colors cursor-pointer ${
              scrolled ? 'text-gray-700 hover:text-blue-500' : 'text-gray-200 hover:text-white'
            }`}>
              Solutions
            </a>
            <a href="#how-it-works" className={`text-sm font-medium transition-colors cursor-pointer ${
              scrolled ? 'text-gray-700 hover:text-blue-500' : 'text-gray-200 hover:text-white'
            }`}>
              How It Works
            </a>
            <a href="#industries" className={`text-sm font-medium transition-colors cursor-pointer ${
              scrolled ? 'text-gray-700 hover:text-blue-500' : 'text-gray-200 hover:text-white'
            }`}>
              Industries
            </a>
            <button className={`px-6 py-2 text-sm font-semibold rounded-lg transition-all cursor-pointer whitespace-nowrap ${
              scrolled 
                ? 'bg-blue-500 text-white hover:bg-blue-600' 
                : 'bg-white text-gray-900 hover:bg-gray-100'
            }`}>
              Contact
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <i className={`ri-menu-line text-2xl ${scrolled ? 'text-gray-900' : 'text-white'}`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden mt-4 py-4 bg-white rounded-lg shadow-lg">
            <div className="flex flex-col space-y-4 px-4">
              <a href="#solutions" className="text-sm font-medium text-gray-700 hover:text-blue-500 cursor-pointer">
                Solutions
              </a>
              <a href="#how-it-works" className="text-sm font-medium text-gray-700 hover:text-blue-500 cursor-pointer">
                How It Works
              </a>
              <a href="#industries" className="text-sm font-medium text-gray-700 hover:text-blue-500 cursor-pointer">
                Industries
              </a>
              <button className="px-6 py-2 bg-blue-500 text-white text-sm font-semibold rounded-lg hover:bg-blue-600 transition-all cursor-pointer whitespace-nowrap">
                Contact
              </button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
